import type { ShopifyAssetResponse } from '..';

import { useQueryShopifyAssets } from '~/modules/shopify';
import { useAssetsStore } from '~/stores/assets';
import { useShopStore } from '~/stores/shop';
import { useMemo } from 'react';

export interface IShopifyAssetResult {
  assets?: ShopifyAssetResponse;
  isLoading: boolean;
  refetch: () => void;
  isRefetching: boolean;
  isFetching: boolean;
}
export const useShopifyAsset = (): IShopifyAssetResult => {
  const assetsStore = useAssetsStore((state) => state.assets);
  const setAssets = useAssetsStore((state) => state.setAssets);
  const shopInfo = useShopStore((state) => state.shopInfo);

  const { isLoading, refetch, isRefetching, isFetching } = useQueryShopifyAssets(undefined, {
    enabled: !!shopInfo?.token,
    onSuccess: setAssets,
  });
  const assets = useMemo(() => assetsStore, [JSON.stringify(assetsStore)]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    assets,
    isLoading,
    refetch,
    isRefetching,
    isFetching,
  };
};
